import { S3_BUCKET_URL, EVENT_TYPE_SAMPLE } from '../../../constants';
import { isProduction } from '../../../utils';

const fifaFolder = `${S3_BUCKET_URL}.files/demo-fifa/`;

const getProjectId = (): string => {
  return isProduction()
    ? 'eb6e8339-32f7-4787-924d-c74040644410'
    : '42569265-cbdd-4f23-bd7c-9fccc14ac542';
};

const getFileId = (type: string): string => {
  switch (type) {
    // attendees

    case 'attendee-1':
      return isProduction()
        ? 'd2da39b4-1f3f-40a1-bf05-497e98b0802b'
        : '62b810c1-5c08-46dd-9173-f5afe157d73b';

    case 'attendee-2':
      return isProduction()
        ? 'adda5630-f188-4051-bade-4cd1cc0e3c14'
        : 'b3b41f74-efc6-46a5-bcd1-f4ae9e45ab21';

    case 'attendee-3':
      return isProduction()
        ? 'b67189ac-94fc-43c6-a25a-9e5a43eade04'
        : '80713251-a6e8-4593-bd7a-c01b949b1949';

    // clips

    case 'clip-a':
      return isProduction()
        ? '90325c1a-f2c4-4152-9e30-254223dc76e7'
        : '20b7ac77-bfd7-414d-8bcf-32358a9c313d';

    case 'clip-b':
      return isProduction()
        ? '9936e603-2b86-4799-9727-eef7a03b0b16'
        : '68a28ff0-9f1e-4fec-9a7e-668f20256771';

    case 'clip-c':
      return isProduction()
        ? 'fb29a18f-23dd-4cfb-9936-e88618d12554'
        : '41c12ed2-dfdf-442d-a1c9-6844cd47f23f';

    case 'clip-d':
      return isProduction()
        ? '1e40ae24-506d-4f4a-9f14-70251ee5e10d'
        : '531b7c52-8d29-40c4-b1e2-4299425462c5';

    case 'clip-e':
      return isProduction()
        ? 'd37d064f-bedc-4a96-aafb-18419a814e19'
        : '5c01586b-1ded-4c8e-9892-2a53e21e3f0c';

    case 'clip-f':
      return isProduction()
        ? 'd2c3c6f7-255f-411c-8302-e9c81e0cc046'
        : '6bb805f4-d8c8-4c38-a99d-0149a652e318';

    default:
      return '';
  }
};

const getClipSelections = (type: string): { [key: number]: string } => {
  switch (type) {
    // creations – matching clips ids

    case 'attendee-1-creation-1':
      return isProduction()
        ? {
            6: '116f484c-7d5a-43fe-91cf-c3970a83161d',
            10: 'a6f8f526-211d-45c8-a77c-22b6d2ead71f',
          }
        : {
            6: '1e1e5334-7451-4bf1-9851-49dcb9bf197b',
            10: '9a55cde1-f67a-421e-9dbc-774ce73635c2',
          };
    case 'attendee-1-creation-2':
      return isProduction()
        ? {
            6: 'a6f8f526-211d-45c8-a77c-22b6d2ead71f',
            10: '116f484c-7d5a-43fe-91cf-c3970a83161d',
          }
        : {
            6: '9a55cde1-f67a-421e-9dbc-774ce73635c2',
            10: '1e1e5334-7451-4bf1-9851-49dcb9bf197b',
          };

    case 'attendee-2-creation-1':
      return isProduction()
        ? {
            6: '131debac-973c-493c-8c66-5d2fb49bcbcc',
            10: '05aae314-a76d-4038-9756-367b564af16e',
          }
        : {
            6: '238aab1f-c9c6-4153-b154-61f59b7e35cc',
            10: 'ea5d2d52-cd5f-4b71-b9d0-ece9e9907115',
          };
    case 'attendee-2-creation-2':
      return isProduction()
        ? {
            6: '05aae314-a76d-4038-9756-367b564af16e',
            10: '131debac-973c-493c-8c66-5d2fb49bcbcc',
          }
        : {
            6: 'ea5d2d52-cd5f-4b71-b9d0-ece9e9907115',
            10: '238aab1f-c9c6-4153-b154-61f59b7e35cc',
          };

    case 'attendee-3-creation-1':
      return isProduction()
        ? {
            6: '1b8de816-3544-4d67-8217-67897b23cfb7',
            10: '13b3197b-7aa3-42fe-aacf-a2dd95857207',
          }
        : {
            6: 'f2e7048e-ba60-4af5-93e5-f4931e25086c',
            10: 'df8b4f6a-50bb-4fcc-bd31-1bad0023cd5e',
          };
    case 'attendee-3-creation-2':
      return isProduction()
        ? {
            6: '13b3197b-7aa3-42fe-aacf-a2dd95857207',
            10: '1b8de816-3544-4d67-8217-67897b23cfb7',
          }
        : {
            6: 'df8b4f6a-50bb-4fcc-bd31-1bad0023cd5e',
            10: 'f2e7048e-ba60-4af5-93e5-f4931e25086c',
          };

    default:
      return { 6: '', 10: '' };
  }
};

export const sampleFifa = {
  event: {
    eventId: getProjectId(),
    name: 'FIFA Sample Project',
    type: EVENT_TYPE_SAMPLE,
    videoMode: 'landscape',
    stage: 'upload',
    payment: { paid: true },
  },
  people: [
    {
      face: {
        elementId: getFileId('attendee-1'),
        name: 'Attendee 1',
      },
      files: [{ url: `${fifaFolder}attendee-1.jpg` }],
    },
    {
      face: {
        elementId: getFileId('attendee-2'),
        name: 'Attendee 2',
      },
      files: [{ url: `${fifaFolder}attendee-2.jpg` }],
    },
    {
      face: {
        elementId: getFileId('attendee-3'),
        name: 'Attendee 3',
      },
      files: [{ url: `${fifaFolder}attendee-3.jpg` }],
    },
  ],
  hlReel: {
    url: `${fifaFolder}highlight-reel.mp4`,
    thumbnailUrl: `${fifaFolder}highlight-reel-thumbnail.png`,
    status: 'valid',
  },
  clips: [
    {
      elementId: getFileId('clip-a'),
      uid: getFileId('clip-a'),
      name: 'Clip A.mp4',
      url: `${fifaFolder}clip-a.mp4`,
      thumbnailUrl: `${fifaFolder}clip-a-thumbnail.png`,
    },
    {
      elementId: getFileId('clip-b'),
      uid: getFileId('clip-b'),
      name: 'Clip B.mp4',
      url: `${fifaFolder}clip-b.mp4`,
      thumbnailUrl: `${fifaFolder}clip-b-thumbnail.png`,
    },
    {
      elementId: getFileId('clip-c'),
      uid: getFileId('clip-c'),
      name: 'Clip C.mp4',
      url: `${fifaFolder}clip-c.mp4`,
      thumbnailUrl: `${fifaFolder}clip-c-thumbnail.png`,
    },
    {
      elementId: getFileId('clip-d'),
      uid: getFileId('clip-d'),
      name: 'Clip D.mp4',
      url: `${fifaFolder}clip-d.mp4`,
      thumbnailUrl: `${fifaFolder}clip-d-thumbnail.png`,
    },
    {
      elementId: getFileId('clip-e'),
      uid: getFileId('clip-e'),
      name: 'Clip E.mp4',
      url: `${fifaFolder}clip-e.mp4`,
      thumbnailUrl: `${fifaFolder}clip-e-thumbnail.png`,
    },
    {
      elementId: getFileId('clip-f'),
      uid: getFileId('clip-f'),
      name: 'Clip F.mp4',
      url: `${fifaFolder}clip-f.mp4`,
      thumbnailUrl: `${fifaFolder}clip-f-thumbnail.png`,
    },
  ],
  creations: {
    [getFileId('attendee-1')]: [
      {
        name: 'template@converted-cluster@Attendee 1',
        uri: '/demo-fifa/attendee-1-creation-1.mp4',
        matchingClips: getClipSelections('attendee-1-creation-1'),
      },
      {
        name: 'template@converted-cluster@Attendee 1',
        uri: '/demo-fifa/attendee-1-creation-2.mp4',
        matchingClips: getClipSelections('attendee-1-creation-2'),
      },
    ],
    [getFileId('attendee-2')]: [
      {
        name: 'template@converted-cluster@Attendee 2',
        uri: '/demo-fifa/attendee-2-creation-1.mp4',
        matchingClips: getClipSelections('attendee-2-creation-1'),
      },
      {
        name: 'template@converted-cluster@Attendee 2',
        uri: '/demo-fifa/attendee-2-creation-2.mp4',
        matchingClips: getClipSelections('attendee-2-creation-2'),
      },
    ],
    [getFileId('attendee-3')]: [
      {
        name: 'template@converted-cluster@Attendee 3',
        uri: '/demo-fifa/attendee-3-creation-1.mp4',
        matchingClips: getClipSelections('attendee-3-creation-1'),
      },
      {
        name: 'template@converted-cluster@Attendee 3',
        uri: '/demo-fifa/attendee-3-creation-2.mp4',
        matchingClips: getClipSelections('attendee-3-creation-2'),
      },
    ],
  },
};
